module.exports = __webpack_public_path__ + "static/1.708bb2b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/1.jpg
// module id = 711
// module chunks = 168707334958949